import { withNamespaces } from "react-i18next";
import { memo } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import {
    Button,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row
} from "reactstrap";
import { ROUTE_PATH_ADMIN_ROOT } from "src/modules/3rd-party-management/constants/AppRoutes";
import { INTERNATIONAL_DATE_TIME_FORMAT } from "src/common/constants";
import DateUtils from "src/services/utils/DateUtils";

const dateUtils = new DateUtils();

const ContactPersonOwnershipModal = ({
    t,
    isOpen,
    toggle,
    data,
    showSupplierLink = true
}) => {
    if (!data) {
        return null;
    }

    const supplierDetailsPath = `${ROUTE_PATH_ADMIN_ROOT}/suppliers/${data.supplierId}/details`;

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" keyboard={false} size="md">
            <ModalHeader toggle={toggle}>
                {t("Contact Person Already Exists")}
            </ModalHeader>

            <ModalBody>
                <p className="mb-3">
                    {t("This contact person is already associated with another third party.")}
                </p>

                <Row className="mb-2">
                    <Col sm="12" md="4">
                        <strong>{t("Full Name")}:</strong>
                    </Col>
                    <Col sm="12" md="8">
                        {data.fullName || '-'}
                    </Col>
                </Row>

                <Row className="mb-2">
                    <Col sm="12" md="4">
                        <strong>{t("Associated Third Party")}:</strong>
                    </Col>
                    <Col sm="12" md="8">
                        {data.supplierName || '-'}
                    </Col>
                </Row>

                {data.createdAt ? (
                    <Row>
                        <Col sm="12" md="4">
                            <strong>{t("Created on")}:</strong>
                        </Col>
                        <Col sm="12" md="8">
                            {dateUtils.convertDateToDate(data.createdAt, INTERNATIONAL_DATE_TIME_FORMAT)}
                        </Col>
                    </Row>
                ) : null}
            </ModalBody>

            <ModalFooter>
                <Button color="primary" outline onClick={toggle}>
                    {t("Close")}
                </Button>

                {showSupplierLink && data.supplierId ? (
                    <Link to={supplierDetailsPath}>
                        <Button color="primary" onClick={toggle}>
                            {t("View Third Party")}
                        </Button>
                    </Link>
                ) : null}
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    memo(ContactPersonOwnershipModal)
);
